import React, { useEffect, useState } from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { openAIAssistant } from './AIFab';

const API = process.env.REACT_APP_BACKEND_URL;
const EXAMPLES = [
  'Kindergeburtstag mit 15 Kindern im Garten',
  'Hüpfburg mit Rutsche für den 15. August',
  'Was passt zu einem Firmen-Sommerfest?',
  'Welche Burg passt auf 6 × 5 Meter?',
];

const useRotatingPlaceholder = () => {
  const [i, setI] = useState(0);
  useEffect(() => { const t = setInterval(() => setI((x) => (x + 1) % EXAMPLES.length), 3500); return () => clearInterval(t); }, []);
  return `KI fragen, z. B. „${EXAMPLES[i]}"`;
};

export default function AISearchSection({ inline = false }) {
  const [enabled, setEnabled] = useState(false);
  const [q, setQ] = useState('');
  const placeholder = useRotatingPlaceholder();

  useEffect(() => { fetch(`${API}/api/ai/config`).then((r) => r.json()).then((c) => setEnabled(!!c.enabled)).catch(() => {}); }, []);
  if (!enabled) return null;

  const ask = (text) => { const t = (text ?? q).trim(); if (!t) return; setQ(''); openAIAssistant(t, 'search'); };

  const form = (
    <form onSubmit={(e) => { e.preventDefault(); ask(); }} className="w-full flex items-center bg-white border-2 border-sky-500 rounded-full pl-4 pr-1 py-1 shadow-sm focus-within:ring-2 focus-within:ring-sky-200" data-testid={inline ? 'hero-ai-search' : undefined}>
      <Sparkles className="h-4 w-4 text-sky-600 shrink-0" />
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={placeholder} maxLength={500} aria-label="KI-Assistent fragen"
        className="flex-1 min-w-0 bg-transparent text-neutral-900 placeholder:text-neutral-400 px-2.5 py-1.5 text-sm focus:outline-none" data-testid="ai-search-input" />
      <button type="submit" disabled={!q.trim()} aria-label="KI fragen" className="inline-flex items-center justify-center rounded-full bg-sky-700 hover:bg-sky-800 text-white h-8 w-8 shrink-0 transition-colors disabled:opacity-50" data-testid="ai-search-submit">
        <ArrowRight className="h-4 w-4" />
      </button>
    </form>
  );
  if (inline) return <div className="w-0 min-w-full">{form}</div>;

  return (
    <section className="py-2 md:py-3" data-testid="ai-search-section">
      <div className="max-w-xl mx-auto px-4 sm:px-6">{form}</div>
    </section>
  );
}
